<div class="relative inline-flex">
  <button
    (click)="navigateToShoppingCart()"
    class="flex h-[47px] items-center font-['Roboto'] text-base font-medium text-cafe hover:cursor-pointer sm:flex-row sm:justify-evenly sm:gap-2 sm:rounded-lg sm:border sm:border-cafe sm:bg-amarillo sm:px-3 sm:shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] sm:hover:bg-[#FFECCE]">
    <ng-content select="[icon]"></ng-content>
    <span class="hidden lg:block">{{ label }}</span>
  </button>
  @if (shoppingCartItemsCount() > 0) {
    <!-- Badge -->
    <span
      [ngClass]="[
        shoppingCartItemsCount() > 99 ? 'h-[32px] w-[32px]' : 'h-[22px] w-[22px]',
        'absolute right-0 top-0 grid translate-x-1/2 place-items-center rounded-full bg-cafe text-xs text-blanco sm:-translate-y-1/2 leading-none select-none, pointer-events-none',
      ]">
      {{ shoppingCartItemsCount() }}
    </span>
  }
</div>
